import { useTranslation } from 'react-i18next';
import { GlobalLoading } from './GlobalLoading';

export default function LoadingPage() {
  const { t } = useTranslation();
  return <GlobalLoading appBarHeight={0} loadingText={t('site.loading')} />;
}
